<div class="cpcontent">
    <h2 style="display:inline-block">Scenario History</h2>
    <div style="display:inline-block;max-width:300px"><sa-select class="inlineform" [(Id)]="scenarioid" [title]="'Scenarios'" [options]="scenarios"></sa-select></div>
    <button class="btn btn-primary" (click)="fetchData()">Fetch Data</button>
    <button class="btn btn-primary" (click)="plot()">Plot</button>
    <div class="row">
        <div class="col-md-4">
            <div *ngIf="this.overview.length == 0">This scenario has no logs for GPS records.</div>
            <table *ngIf="this.overview.length > 0" class="table table-bordered">
                <thead>
                    <tr>
                        <th>Phone Session  <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('name')"></i></th>
                        <th>Count</th>
                        <th>First Date <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('date')"></i> </th>
                        <th>Select</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of overview">
                        <td class="link" (click)="selectByPhoneInfo(b)">{{b.name}}</td>
                        <td>{{b.count}}</td>
                        <td>{{b.firstRecord.dateCreated | date: 'shortDate'}}</td>
                        <td class="link" (click)="select(b)">{{b.select ? "Yes":"No"}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-8">
            <!-- <div *ngIf="showmapheader" style="display:inline-block;">
                <h5>{{selectedScenario.scenarioname}}, {{selectedScenario.organizationname}} with phoneinfo {{phoneinfo}}</h5>
            </div>
            <button class="btn btn-primary btn-sm" (click)="showWalk()">Show Walk</button>
            <sa-input-number style="display:inline-block;max-width:150px;margin-left:10px" [(text)]="walkInterval" [title]="'Interval [ms]'" [required]="'none'"></sa-input-number>
            <sa-input-boolean style="display:inline-block;max-width:150px;margin-left:10px" [(checked)]="showAccuracy" [title]="'Show Accuracy'" [required]="'none'"></sa-input-boolean> -->
            <div #pagemap2 style="width:100%;height:600px"></div>
        
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Phone Info</th>
                        <th>Color</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of pisc">
                        <td>{{b.name}}</td>
                        <td [ngStyle]="{'background-color':b.color}">{{b.color}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</div>
